/* eslint-disable react/no-danger */
import dynamic from 'next/dynamic';
import { memo } from 'react';
import { I_ArticleInteraction, I_Post } from '@containers/Home/types';
import { DialogHotspotArticleWrapper } from './styled';

const DialogContainer = dynamic(() => import('@components/DialogContainer'));

interface Props {
  width?: number | string;
  post?: I_Post;
  visible: boolean;
  onCancel: () => void;
  size?: I_ArticleInteraction['appearance_size'];
  layout?: I_ArticleInteraction['appearance_layout'];
}

export const DialogArticle = ({
  visible,
  onCancel,
  post,
  width,
  size,
  layout,
}: Props) => {
  return (
    <DialogContainer
      visible={visible}
      onCancel={onCancel}
      maskClosable
      centered
      width={width || '720px'}
      bodyStyle={{ maxWidth: width || '720px', width: '100%' }}
    >
      <DialogHotspotArticleWrapper
        className={`${layout !== 'leftToRight' ? '' : 'layout-leftToRight'} ${
          size !== 'compact' ? '' : 'size-compact'
        }`}
      >
        <div className="header">
          {post?.thumbnail?.src && (
            <img
              className="thumb"
              src={post?.thumbnail?.src}
              alt={post?.thumbnail?.name}
            />
          )}
          {layout !== 'leftToRight' && (
            <div className="title">{post?.title || ''}</div>
          )}
        </div>
        <div className="body hide-scrollbar">
          {layout === 'leftToRight' && (
            <div className="title">{post?.title || ''}</div>
          )}
          <div
            className="content ctn__html sun-editor sun-editor-editable"
            dangerouslySetInnerHTML={{ __html: post?.content || '' }}
          />
        </div>
      </DialogHotspotArticleWrapper>
    </DialogContainer>
  );
};

export default memo(DialogArticle);
